module.exports = __webpack_public_path__ + "static/media/ncj_bangle_0011.717b4c0d.jpg";